// @flow
import ContentConfigurationElements from "./ContentConfigurationElements";

/**
 */
class ContentConfigurationQuestions {
  _configuration: Object;

  /**
   */
  constructor(configuration: Object) {
    this._configuration = configuration || null;
  }

  /**
   */
  hasConfig(): boolean {
    return (
      this.question.hasConfig() ||
      this.options.hasConfig() ||
      this.answers.hasConfig()
    );
  }

  /**
   */
  get question(): ContentConfigurationElements {
    if (this._configuration === null) {
      return new ContentConfigurationElements([]);
    }

    return new ContentConfigurationElements(
      this._configuration.questionElements,
    );
  }

  /**
   */
  get options(): ContentConfigurationElements {
    if (this._configuration === null) {
      return new ContentConfigurationElements([]);
    }

    return new ContentConfigurationElements(this._configuration.optionElements);
  }

  /**
   */
  get answers(): ContentConfigurationElements {
    if (this._configuration === null) {
      return new ContentConfigurationElements([]);
    }

    return new ContentConfigurationElements(
      this._configuration.givenAnswerElements,
    );
  }
}

export default ContentConfigurationQuestions;
